<template>
<div>
    <h1 class="subtitle">Usuarios</h1>
    <div class="nj-cols">
        <div class="nj-card">
            <div class="nj-cols form c2 l-c3">
                <div>
                    <div class="nj-label">Usuario</div>
                    <input type="text" class="nj-text" v-model="filters.usu_search" ref="usu_search" @keyup.enter="buscar()">
                </div>
                <div>
                    <div class="nj-label">Tipo</div>
                    <select name="" id="" class="nj-select" v-model="filters.tiu_id" @change="buscar()">
                        <option v-for="item in tiposUsuario" :key="item.tiu_id" :value="item.tiu_id">{{ item.tiu_nombre }}</option>tr
                    </select>
                </div>
            </div>
            <Buttons line>
                <template v-slot:default>
                    <button class="nj-button align-self-flex-end" @click="buscar()">Buscar</button>
                    <button class="nj-button align-self-flex-end c-green" @click="openRegistrar()">Nuevo</button>
                </template>
            </Buttons>
        </div>
        <div class="nj-card">
            <b-table :data="usuarios" :paginated="isPaginated" :per-page="perPage" :current-page.sync="currentPage" :pagination-simple="isPaginationSimple" :pagination-position="paginationPosition"
                :default-sort-direction="defaultSortDirection" :pagination-rounded="isPaginationRounded" :sort-icon="sortIcon" :sort-icon-size="sortIconSize" aria-next-label="Next page"
                aria-previous-label="Previous page" aria-page-label="Page" aria-current-label="Current page">
                <template slot-scope="props">
                    <b-table-column label="DNI" header-class="is-info">{{ props.row.usu_dni }}</b-table-column>
                    <b-table-column label="Usuario" header-class="is-info">{{ props.row.usu_nombre }} {{ props.row.usu_apellido }}</b-table-column>
                    <b-table-column label="Tipo" header-class="is-info">{{ props.row.tiu_nombre }}</b-table-column>
                    <b-table-column label="Estado" header-class="is-info">
                        <b-field>
                            <b-tag :class="tagEstado(props.row.usu_estado)">{{ props.row.usu_estado_nombre }}</b-tag>
                        </b-field>
                    </b-table-column>
                    <b-table-column label="Opciones" header-class="is-info">
                        <div class="nj-flx">
                            <button class="nj-button icon" @click="openModificar(props.row.usu_id)" title="Modificar"><i class="mdi mdi-pencil"></i></button>
                        </div>
                    </b-table-column>
                </template>
            </b-table>
        </div>
    </div>
    <RegistrarUsuario v-if="showRegistrar" @close="closePopups($event)"></RegistrarUsuario>
    <ModificarUsuario v-if="showModificar" :usu_id="usu_id" @close="closePopups($event)"></ModificarUsuario>
</div>
</template>

<script>
import Estado from "../../constants/estado"
import TipoUsuario from "../../constants/tipoUsuario"
import { UsuarioService } from "../../rest"
import RegistrarUsuario from "./RegistrarUsuario"
import ModificarUsuario from "./ModificarUsuario"
import { Buttons } from "./../components"
import Keyboard from "../../util/keyboard"

export default {
    name: "Usuario",
    components: {
        RegistrarUsuario,
        ModificarUsuario,
        Buttons
    },
    data() {
        return {
            filters: {
                usu_search: null,
                tiu_id: null,
            },
            usu_id: null,
            usuarios: [],
            tiposUsuario: [],
            showRegistrar: false,
            showModificar: false,
            isPaginated: true,
            isPaginationSimple: false,
            isPaginationRounded: false,
            paginationPosition: "bottom",
            defaultSortDirection: "asc",
            sortIcon: "arrow-up",
            sortIconSize: "is-small",
            currentPage: 1,
            perPage: 10,
        }
    },
    methods: {
        buscar() {
            this.usuarios = []
            UsuarioService
                .buscar(this.filters).then(
                    response => {
                        this.usuarios = response.data
                    },
                    error => {
                        Toast.error(error)
                        console.error(`error: `, error)
                    }
                )
        },
        tagEstado(id) {
            return Estado.Tag(id)
        },
        openRegistrar(id) {
            this.usu_id = id
            this.showRegistrar = true
        },
        openModificar(id) {
            this.usu_id = id
            this.showModificar = true
        },
        closePopups(condition) {
            this.showRegistrar = false
            this.showModificar = false
            this.usu_id = null
            if (condition) {
                this.buscar()
            }
        }
    },
    mounted() {
        this.tiposUsuario.push(TipoUsuario.data.EMPLEADO)
        this.filters.tiu_id = TipoUsuario.data.EMPLEADO.tiu_id
        this.$refs.usu_search.focus()
        this.buscar()
    }
}
</script>

<style scoped></style>